import { createLenteHooks } from '@festina-life/lente'

import type { GeneralConfiguration } from './appConfiguration/generalConfiguration'

const { useHook, useService, useComponent, useComponentCollection } =
  createLenteHooks<GeneralConfiguration>()

export { useComponent, useComponentCollection, useHook, useService }
